<template lang="pug">
.no-use-container(v-if="show")
  .shadow(@click="closeModal")
  .no-use(@click="closeModal")
    .no-use-top
      img.no-use-close(src="https://m.hellobike.com/resource/gallery/61/jnlkOWH5wR.png?x-oss-process=image/quality,q_80" @click="closeModal")
    .no-use-bottom
      .no-use-i-know(@click="closeModal") 我知道了
</template>
<script>
import { UBT } from '@hb/tianqi/lib/ubt.h5';

export default {
  components: {
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
    };
  },
  destroyed() {
  },
  created() {
  },
  methods: {
    closeModal() {
      UBT.clickButton({
        pageId: 'platform_savemoneycard_page',
        buttonName: 'platform_refund_rule',
        categoryId: 'platform',
        businessInfo: {},
      });
      this.$emit('update:show', false);
    },
  },
};
</script>
<style lang="less" scoped>
.no-use-container {
  font-family: PingFangSC-Medium, PingFang SC, sans-serif;
  position: fixed;
  bottom: 0;
  z-index: 222;
  width: 100%;
  height: 3.92rem;

  .no-use {
    .no-use-top {
      height: 1.37rem;
      background-image: url(https://m.hellobike.com/resource/gallery/61/XGuDvCNLYK.png?x-oss-process=image/quality,q_80);
      background-size: 100% 100%;
      z-index: 223;
      position: relative;

      img.no-use-close {
        position: absolute;
        top: 0.16rem;
        right: 0.16rem;
        height: 0.16rem;
        width: 0.16rem;
      }
    }

    .no-use-bottom {
      position: relative;
      z-index: 223;
      height: 2.55rem;
      background-size: 100% 100%;
      background-image: url(https://m.hellobike.com/resource/gallery/61/I9pvatJon0.png?x-oss-process=image/quality,q_80);
      padding-top: 1.73rem;
      padding-left: 0.2rem;
      padding-right: 0.2rem;

      .no-use-i-know {
        height: 0.48rem;
        background: linear-gradient(90deg, #fa8621 0%, #fa3a00 100%);
        border-radius: 0.08rem;
        text-align: center;
        line-height: 0.48rem;
        font-family: PingFangSC, PingFang SC, sans-serif;
        font-weight: 500;
        font-size: 0.16rem;
        color: #fff;
      }
    }
  }

  .shadow {
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    background: #000;
    opacity: 0.7;
    z-index: 100;
  }
}
</style>
